export const hasFreeShipping = data => {
	let badge = false;
	let comPrice =
		data.freeExpressShippingAbove !== 'undefined' &&
		data.freeExpressShippingAbove !== null
			? data.freeExpressShippingAbove
			: data.freeStandardShippingAbove !== 'undefined' &&
			  data.freeStandardShippingAbove !== null
			? data.freeStandardShippingAbove
			: null;
	if (comPrice !== null && data.price > comPrice) {
		badge = true;
	}
	return badge;
};

export const requestData = props => {
	let limit =
		(window.innerWidth > 767 && window.innerWidth < 991) ||
		(window.innerWidth > 1199 && window.innerWidth < 1600)
			? 21
			: 20;
	let banners = [];
	if (props.banners) {
		let bannerArr = Object.keys(props.banners);
		for (let item of bannerArr) {
			if (props.banners[item].imageUrl) banners.push(props.banners[item]);
		}
	}
	limit = limit - (banners.length > 2 ? 2 : banners.length);
	if (props.isAuction) {
		let data = {
			 
			price_from: props.filters.price_from || null,
			 
			price_to: props.filters.price_to || null,
			categories: props.category ? [props.category] : [],
			page: props.filters.page ? Number(props.filters.page) : 1,
			limit,
			banners,
		};
		if (props.filters.category) {
			data.categories = [];
			data.categories.push(...props.filters.category.split('|'));
		}
		return data;
	} else {
		let data = {
			filter: {
				categories: props.category ? [props.category] : [],
				retailers: props.filters.retailer
					? props.filters.retailer.split('|')
					: [],
				manufacturers: props.filters.brand
					? props.filters.brand.split('|')
					: [],
				price: {
					min: props.filters.price_from,
					max: props.filters.price_to,
				},
			},
			sortBy: Number(props.filters.sortBy) || 0,
			page: props.filters.page ? Number(props.filters.page) : 1,
			limit,
			banners,
		};

		if (props.brand) {
			data.filter.manufacturer = props.brand;
		}

		if (props.retailerId) {
			data.isStore = true;
			data.filter.retailer = props.retailerId;
			data.filter.retailers = [props.retailerId];
		}

		if (props.filters.category) {
			data.filter.categories = [];
			data.filter.categories.push(...props.filters.category.split('|'));
		}

		if (props.filters.options) {
			data.filter.options = [];
			data.filter.options.push(...props.filters.options.split('||'));
		}

		if (props.filters.name) {
			data.filter.name = props.filters.name;
		}
		if (props.filters.location) {
			data.filter.location = props.filters.location;
		}
		if (props.filters.longitude) {
			data.filter.longitude = props.filters.longitude;
		}
		if (props.filters.latitude) {
			data.filter.longitude = props.filters.latitude;
		}
		if (props.filters.refineBy) {
			data.filter.refineBy = props.filters.refineBy;
		}
		if (props.filters.refineKey) {
			data.filter.longitude = props.filters.refineKey;
		}
		if (props.filters.radius) {
			data.filter.radius = props.filters.radius;
		}
		if (props.filters.shipping) {
			data.filter.shipping = props.filters.shipping?.split('|');
		}
		return data;
	}
};

export const product = (p, currencyData, props) => {
	const price = {
		buy: p.rrp,
		strike: p.strikethrough,
	};
	let freeShipping = false;
	let retailerData = {};
	let wishlistData = {};
	let retailerName = '';
	if (props.store) {
		const rp = p.retailer_products.find(
			i => i.retailer_id === props.retailerId,
		);

		if (rp) {
			price.buy = rp.buy_price;
			if (rp.compare_at_price && rp.compare_at_price > rp.buy_price) {
				price.strike = rp.compare_at_price;
			} else if (rp.discounted_price && rp.discounted_price > 0) {
				price.strike = rp.buy_price;
				price.buy = rp.discounted_price;
			} else {
				price.strike = 0;
			}
		}

		const retailer = p.retailer.find(i => i._id === props.retailerId);
		if (retailer) {
			freeShipping = hasFreeShipping({
				...retailer,
				price: price.buy,
			});
			retailerName = `${retailer.firstname} ${retailer.lastname || ''}`;
			retailerData = retailer;
		}
	} else {
		if (p.retailer.length) {
			var retailerDatasss = p.retailer
				.filter(itm => itm.charity && itm.charity._id)
				.sort(
					(a, b) =>
						b.retailerDonation.donation_value -
						a.retailerDonation.donation_value,
				);
			freeShipping = hasFreeShipping({...p.retailer[0], price: price.buy});
			retailerName = `${p.retailer[0].firstname} ${
				p.retailer[0].lastname || ''
			}`;
			retailerData = p.retailer[0];
			if (retailerDatasss.length) {
				retailerData = retailerDatasss[0];
			}
		}
	}

	if (price.strike) {
		price.discount = Math.round(
			((price.strike - price.buy) / price.strike) * 100,
		);
	}
	if (p.wishlistData) wishlistData = p.wishlistData;
	return {
		name: p.product_name,
		url: productUrl(p, props),
		image: image(p),
		manufacturer: p.manufacturer.name,
		price,
		freeShipping,
		retailerName,
		retailerData,
		variances: p.variances,
		slug: p.slug,
		_id: p._id,
		wishlistData,
		auction: p.auctions || null,
		auctionPrice: p.auctionPrice || null,
		total_stock: p.total_stock || 0,
	};
};

const image = product => {
	let image = '/assets/svg/placeholder.svg';

	if (product.image && product.image.length) {
		image = product.image[0].image_url;
	} else if (product.variances && product.variances.length) {
		image =
			product.variances[0].image_urls && product.variances[0].image_urls.length
				? product.variances[0].image_urls[0].image
				: '';
	}
	return image || '/assets/svg/placeholder.svg';
};

const productUrl = (p, props) => {
	let url = `/product/${p.slug}`;

	if (props.brand) {
		url += `/${props.brand}`;
	}

	if (props.store) {
		url = `/product/store/${props.store}/${p.slug}`;
	}

	if (props.category) {
		url += `?category=${props.category}`;
	}

	return url;
};

export const pageUrl = (props, slug = false) => {
	let url = '/products';
	if (props.isAuction) {
		url = '/drop-auctions/all';
	}

	if (props.brand) {
		url = `/brand/${props.brand}`;
	}

	if (props.store) {
		url = `/stores/${props.store}`;
	}
	if (props.wishlist) {
		url = `/wishlist`;
	}
	if (slug) {
		if (slug !== 'NA') url += `/${slug}`;
	} else if (props.category) {
		url += `/${props.category}`;
	}
	return url;
};
